import { DataBinaryImage } from './DataBinaryImage'
import { DataBinary } from '@/utils/dataBinaryToUrl'

export function DataImage({
  dataBinary,
  className,
  alt,
  defaultImage,
}: {
  dataBinary?: DataBinary
  className?: string
  alt?: string
  defaultImage: string
}) {
  let image
  if (dataBinary) {
    image = (
      <DataBinaryImage
        dataBinary={dataBinary}
        alt={alt}
        className={className}
        placeholderImage={defaultImage}
      />
    )
  }
  if (!image) {
    image = <img className={className} src={defaultImage} alt={alt} />
  }
  return image
}
